import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class StyleLine extends BasicEntity {
comparator: string;
css: string;
formula: string;
key: string;
kind: string;
order: number | null;
renderer: string;
}

